export const ADD_OBJECT_TO_STORE = "ADD_OBJECT_TO_STORE";
export const ADD_EMPTY_OBJECT_TO_PART_OF_STORE = "ADD_EMPTY_OBJECT_TO_PART_OF_STORE";
export const DELETE_OBJECT_FROM_PART_OF_STORE = "DELETE_OBJECT_FROM_PART_OF_STORE";
export const CHANGE_CHECKBOX = "CHANGE_CHECKBOX";
export const SET_INFO_FROM_DB = "SET_INFO_FROM_DB";
export const CHANGE_UBOS = "CHANGE_UBOS";
export const CLEAR_STORE = "CLEAR_STORE";
